module.exports = __webpack_public_path__ + "static/scratched_texture-587e1f5bcbe77eba75ac82de86b10f0c.jpg";